import React from 'react';
import ZLChart from './zlChart';
import './main.css';
import Typography from "@material-ui/core/Typography";

// Landing Pages Section 1D
function PageHeaderSection(props) {
    return (
        <section className="page-header-section-whatFix">
            <div className="page-header-section__header-whatFix">
                <Typography variant="h3">
                    {props.children}
                </Typography>
            </div>
            <ZLChart />
        </section>
    );
}

export default PageHeaderSection;